<template>
    <div>
        <div class="profile-style">
            <h5 class="mb-4">Faq Website</h5>
            <div class="tabel-action mb-4">
                <button type="button" v-b-modal.modal-Faq class="btn bg-white bdr-15 btn-block btn-lg"><i class="uil uil-plus mr-2"></i>Add Faq</button>
            </div>

            <draggable
                v-bind="dragOptions"
                v-model="faq"
                handle=".handle"
                @start="drag = true"
                @end="drag = false"
                >

                <transition-group type="transition" :name="!drag ? 'flip-list' : null">
                    <div v-for="(data,index) in faq" :key="data.id" class="link mb-3">
                        <div class="link-drag handle align-items-center d-flex">
                            <i class="uil uil-draggabledots"></i>
                        </div>
                        <div class="link-body">
                            <div class="link-content">
                                <div class="link-item pr-5">
                                    <div><strong>{{data.title}}</strong></div>
                                </div>
                                <div class="link-switch d-flex align-items-center">
                                    <a href="#" v-b-modal.modal-Faq v-on:click.prevent="ASSIGN_FORM_FAQ(data)" class="act mb-0">
                                        <i class="uil uil-pen"></i>
                                        <span class="link-tx"> Edit</span>
                                    </a>
                                    <a href="#" v-on:click.prevent="alertDelete(data.id,index)" class="act mb-0">
                                        <i class="uil uil-trash-alt"></i>
                                        <span class="link-tx"> Delete</span>
                                    </a>
                                </div>
                            </div>
                        </div>

                    </div>
                </transition-group>

            </draggable>
        </div>

        <b-modal id="modal-Faq" size="lg" centered hide-footer :title="modal_title" @hidden="CLEAR_FORM_FAQ">

            <ValidationObserver ref="form">
                <div class="row">

                    <div class="col-md-12">
                         <validation-provider rules="required" v-slot="{ errors }">
                            <div class="form-group">
                                <label>Question</label>
                                <input v-model="formfaq.title" type="text" class="form-control" name="categories">
                                <div class="invalid-input">{{ errors[0] }}</div>
                            </div>
                        </validation-provider>
                    </div>
                    <div class="col-md-12">
                        <div class="form-group">
                            <label>Answer</label>
                            <textarea class="form-control" v-model="formfaq.desc"></textarea>
                        </div>
                    </div>
                </div>

                <div class="text-right mt-4">
                    <button v-on:click="validationForm(formfaq.id)" v-bind:class="loading ? 'btn-progress' : ''" type="button" class="btn btn-new">
                        Save Faq
                    </button>
                </div>

            </ValidationObserver>

        </b-modal>
    </div>
</template>

<script>
    import { mapState, mapActions, mapMutations } from 'vuex'
    import {ValidationProvider, ValidationObserver } from "vee-validate";
    import draggable from 'vuedraggable'

    export default{
        data(){
            return{
                drag: false,
                loading:false,
                modal_title : 'Add Faq',
            }
        },
        watch:{
            'formfaq':function(val){
                if(val.id){
                    this.modal_title = 'Edit Faq'
                }else if(!val.id){
                    this.modal_title = "Add Faq"
                }
            },
        },
        components: {
            ValidationProvider,
            ValidationObserver,
            draggable,
        },
        computed:{
            ...mapState('WebsiteControl', {
                website: state => state.website,
                formfaq: state => state.formfaq
            }),

            dragOptions() {
                return {
                    animation: 200,
                    group: "description",
                    disabled: false,
                    ghostClass: "ghost"
                };
            },
            faq: {
                get() {
                    return this.website.faq
                },
                set(value) {
                    this.SET_POSITION_FAQ(value)
                    this.updatePositionFaq(value)
                }
            }
        },
        methods:{
            ...mapMutations('WebsiteControl', ['SET_POSITION_FAQ','CLEAR_FORM_FAQ','ASSIGN_FORM_FAQ']),
            ...mapActions('WebsiteControl', ['getWebsite','createFaq','updateFaq','deleteFaq','updatePositionFaq']),

            validationForm: function(id) {
                this.$refs.form.validate().then(success => {
                    if (!success) {
                        setTimeout(() => {
                            const errors = Object.entries(this.$refs.form.errors)
                                .map(([key, value]) => ({ key, value }))
                                .filter(error => error["value"].length);
                            this.$refs.form.refs[errors[0]["key"]].$el.scrollIntoView({
                                behavior: "smooth",
                                block: "center"
                            });
                        }, 100);
                    }else{
                        this.loading = true

                        if(id){

                            this.updateFaq(this.formfaq).then(() => {
                                this.loading = false
                                this.$bvModal.hide('modal-Faq')
                                this.getWebsite(this.$route.params.id)
                                this.$toast.success('Successfully Update Faq')
                            }).catch((error) => {
                                console.log(error)
                                this.loading = false
                                this.$toast.warning('Sorry, Something Error')
                            })

                        }else{

                            this.createFaq(this.formfaq).then(() => {
                                this.loading = false
                                this.$bvModal.hide('modal-Faq')
                                this.getWebsite(this.$route.params.id)
                                this.$toast.success('Successfully Added Faq')
                            }).catch((error) => {
                                console.log(error)
                                this.loading = false
                                this.$toast.warning('Sorry, Something Error')
                            })
                        }
                    }
                });
            },
            alertDelete:function(id,index){
                this.$swal({
                    title: 'Confirmation',
                    icon: 'warning',
                    text: "Are you sure you delete this faq data? This action cannot be undone",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Delete',
                    cancelButtonText: 'Cancel'
                }).then((result) => {
                    if (result.value) {
                        this.deleteFaq(id).then(
                            this.$toast.success('Successfully Deleting Faq'),
                            this.website.faq.splice(index, 1)
                        ).catch((error) => {
                            console.log(error)
                            this.$toast.warning('Sorry, Something Error')
                        })
                    }
                })
            },
        }
    }

</script>

<style scoped>
    .img-sh img{
        width: 300px;
    }
    .link-icon img,
    .link-icon .no-img{
        width: 60px;
        height: 60px;
    }
    .btn-outline-secondary.qr{
        width: 100px;
        height: 100px;
    }
    .category-themes .btn-outline-secondary.qr:nth-child(3) img{
        width: 45px !important;
    }
    .btn-outline-secondary{
        border-color: #e4e6fc;
    }
    .btn-outline-secondary.active,
    .btn-outline-secondary:hover {
        background: #e4e6fc !important;
        border-color: #e4e6fc !important;
    }

</style>
